import { IconButton, Typography } from "@/shared/ui/atoms"
import { CloseIcon } from "@/shared/ui/atoms"

interface ModalHeaderProps {
  title?: string
  titlePosition?: "center" | "left" | "right"
  paddingTopClassName?: string
  marginBottomClassName?: string
  onClose: () => void
}

const ModalHeader = ({
  title,
  titlePosition = "left",
  paddingTopClassName = "pt-6",
  marginBottomClassName = "mb-5",
  onClose,
}: ModalHeaderProps) => {
  return (
    <div className={`flex items-center justify-between px-4 ${paddingTopClassName} ${marginBottomClassName}`}>
      <Typography size={24} lineHeight={28} className={`font-semibold text-[${titlePosition}]`}>
        {title}
      </Typography>
      <IconButton onClick={onClose}>
        <CloseIcon size={24} />
      </IconButton>
    </div>
  )
}

export default ModalHeader
